import { PubSub } from "@/shared/utils/pubSub";
import { useSubscribe } from "@/shared/utils/useSubscribe";

type FieldType = "event" | "familyMember";
type Callback = (param: { fieldName: string; type: FieldType; newItemIndex: number; mappedAssertion: string }) => void;

const addFieldPubSub = new PubSub<Callback>();

export const publishAddField = addFieldPubSub.publish;
export const useOnAddField = (callback: Callback) => useSubscribe(addFieldPubSub, callback);
